import React from "react";
import styled from "styled-components";
import { theme } from "../../../../theme";

interface Props {
  visible?: boolean;
  text?: string;
}
const ToolTip: React.FC<Props> = ({ visible, text }) => {
  return visible ? (
    <StyledToolTipContainer>
      <StyledToolTipWrapper>
        <StyledArrow />
        <StyledToolTip>{text}</StyledToolTip>
      </StyledToolTipWrapper>
    </StyledToolTipContainer>
  ) : null;
};

const StyledToolTipContainer = styled.div`
  position: relative;
`;
const StyledToolTip = styled.div`
  background-color: ${theme.colors.mainPrimary3};
  padding: 8px 16px;
  color: white;
  white-space: pre;
  border-radius: 8px;
`;
const StyledArrow = styled.div`
  width: 12px;
  height: 10px;

  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 12px solid ${theme.colors.mainPrimary3};
`;
const StyledToolTipWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  left: -97px;
  top: 10px;
`;
export default ToolTip;
